import { gql } from 'graphql-request'

export const CANCEL_PAYMENT_TRUE_MONEY = gql`
  mutation CancelPaymentTrueMoney($transactionId: String!) {
    cancelPaymentTrueMoney(transactionId: $transactionId) {
      message
    }
  }
`
